import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, SlidersIcon, SparklesIcon } from 'lucide-react';
const steps = [{
  icon: DownloadIcon,
  number: '1',
  title: 'Descarga',
  description: 'Recibes el acceso inmediato a tu guía digital apenas completas el pedido.'
}, {
  icon: SlidersIcon,
  number: '2',
  title: 'Ajusta',
  description: 'Sigues las recomendaciones de tiempos y tipos de alimentos de la primera semana.'
}, {
  icon: SparklesIcon,
  number: '3',
  title: 'Reactiva',
  description: 'Sientes cómo la energía vuelve y la ropa empieza a quedar más holgada en solo 21 días.'
}];
export function HowItWorks() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-81">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-82">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-serif text-3xl md:text-4xl text-forest mb-12 text-center" data-id="element-83">
          Cómo funciona
        </motion.h2>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-84">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="text-center" data-id="element-85">
              <div className="inline-flex items-center justify-center w-20 h-20 bg-sage-primary rounded-full mb-6" data-id="element-86">
                <step.icon className="w-10 h-10 text-white" data-id="element-87" />
              </div>
              <div className="font-serif text-5xl text-terracotta/20 mb-4" data-id="element-88">
                {step.number}
              </div>
              <h3 className="font-serif text-2xl text-forest mb-3" data-id="element-89">
                {step.title}
              </h3>
              <p className="text-forest/70 leading-relaxed" data-id="element-90">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}